import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCourse,
    fetchCourseFilter,
    courseClear,
    courseCategoryAvailableClear,
    courseCategoryAvailableApproveClear,
    courseCategoryApproveClear,
    courseCategoryClear,
    courseTestAvailableClear,
    courseTestClear,
    courseWorkCycleAvailableClear,
    courseWorkCycleClear,
    courseFilterClear,
    courseClientProcedureAvailableClear,
    courseClientProcedureClear,
    courseHomologousProcedureAvailableClear,
    courseHomologousProcedureClear

} from 'app/actions/CourseActions';
import { attachmentClear } from "app/actions/AttachmentActions";
import { clearCourseMultimedia } from 'app/actions/CourseMultimediaActions';
import { getCourse, getCourseFilter, getIsLoadingCourse } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import moment from 'moment';
import isEmpty from 'app/utils/IsEmpty';

export default function CourseTableContainer(props) {
    const { confirm } = Modal;

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const {
        siteId
    } = useSelector(state => state.Auth)

    const {
        Permissions
        , Roles
    } = useSelector(state => state.Auth.item.User);

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const isSuperAdmin = () => {
        let indx = Roles.findIndex((x) => x.NameRole === "Super Administrador")

        if (indx != -1) {
            return true
        } else {
            return false;
        }
    }

    const validateAdminGeneralRol = () => {
        let findRol = Roles.find(rol => rol.NameRole.includes("Administrador General"))
        return findRol ? true : false;
    }

    const permisosArray = () => {
        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("Modulo de")).map(item => {
            return item.NameResource;
        })
        let response = [];
        permissions.forEach(row => {
            switch (row) {
                case "ModuleCourseDocument":
                    response.push("ModuleCourseDocument");
                    break;
                case 'ModuleCourseCategory':
                    response.push("ModuleCourseCategory");
                    break;
                case "ModuleCourseMultimedia":
                    response.push("ModuleCourseMultimedia");
                    break;
                case "ModuleCourseEvaluation":
                    response.push("ModuleCourseEvaluation");
                    break;
                case "ModuleCourseDutyCycle":
                    response.push("ModuleCourseDutyCycle");
                    break;
                case "ModuleCourseClientProcedure":
                    response.push("ModuleCourseClientProcedure");
                    break;
            }

        })
        return response
    }

    const columns = [
        // {
        //     title: 'Usuario',
        //     dataIndex: 'usuario',
        //     key: 'usuario',
        //     sorter: true,
        //     width: 150
        // },
        {
            title: 'Folio',
            dataIndex: 'courseFolio',
            key: 'courseFolio',
            sorter: true,
            width: 150,
        },
        {
            title: 'Código',
            dataIndex: 'courseCode',
            key: 'courseCode',
            sorter: true,
            width: 200
        },
        {
            title: 'Nombre',
            dataIndex: 'courseName',
            key: 'courseName',
            ellipsis: true,
            sorter: true,
            width: 300
        },
        {
            title: 'Descripción',
            dataIndex: 'courseDescription',
            key: 'courseDescription',
            ellipsis: true,
            sorter: true,
            width: 450
        },
        {
            title: 'Folio Evaluación',
            dataIndex: 'testFolio',
            key: 'testFolio',
            sorter: true,
            width: 150
        },
        {
            title: 'Folio CT',
            dataIndex: 'testCTFolio',
            key: 'testCTFolio',
            sorter: true,
            width: 150
        },
        {
            title: 'Tipo de capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            ellipsis: true,
            sorter: true,
            width: 250
        },
        {
            title: 'Especialidad / Sistema',
            dataIndex: 'systemSpecialty',
            key: 'systemSpecialty',
            sorter: true,
            ellipsis: true,
            width: 250
        },
        {
            title: 'Version',
            dataIndex: 'courseVersion',
            key: 'courseVersion',
            sorter: true,
            width: 100
        },
        {
            title: 'Fecha creación',
            dataIndex: 'courseDateCreation',
            className: 'alignCenter',
            key: 'courseDateCreation',
            sorter: true,
            width: 160,
            render: (courseDateCreation) => {
                return moment(courseDateCreation).locale('es').format('L')
            }
        },
        {
            title: 'Fecha modificación',
            dataIndex: 'courseDateModification',
            key: 'courseDateModification',
            className: 'alignCenter',
            sorter: true,
            width: 160,
            render: (courseDateModification) => {
                if (courseDateModification) {
                    return moment(courseDateModification).locale('es').format('L')
                } else {
                    return <label>N/A</label>
                }
            }
        },
        {
            title: 'Documento',
            dataIndex: 'document',
            key: 'document',
            className: 'alignCenter',
            sorter: true,
            width: 120,
            render: (hasDocument, record) => (
                hasDocument === 2 ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> :  hasDocument === 1 ? <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} /> : <Icon type="stop" style={{ fontSize: '20px', color: '#9E9E9E' }} />
            )
        },
        {
            title: 'Puesto(s)',
            dataIndex: 'category',
            key: 'category',
            className: 'alignCenter',
            sorter: true,
            width: 120,
            render: (hasCategory, record) => (
                hasCategory === 1 ?  <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} /> : (hasCategory === 2 ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="stop" style={{ fontSize: '20px', color: '#9E9E9E' }} />  )
                
           )
        }, 
        {
            title: 'Multimedia',
            dataIndex: 'erapid',
            key: 'erapid',
            className: 'alignCenter',
            sorter: true,
            width: 120,
            render: (hasErapid, record) => (
                hasErapid === 1 ?  <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} /> : (hasErapid === 2 ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="stop" style={{ fontSize: '20px', color: '#9E9E9E' }} />  )
            )
        },
        {
            title: 'Evaluación',
            dataIndex: 'test',
            key: 'test',
            className: 'alignCenter',
            sorter: true,
            width: 120,
            render: (hasTest, record) => (
                hasTest === 1 ?  <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} /> : (hasTest === 2 ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="stop" style={{ fontSize: '20px', color: '#9E9E9E' }} />  )
            )
        },
        {
            title: 'Ciclo de trabajo',
            dataIndex: 'work',
            key: 'work',
            className: 'alignCenter',
            sorter: true,
            width: 150,
            render: (hasWork, record) => (
                hasWork === 1 ?  <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} /> : (hasWork === 2 ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="stop" style={{ fontSize: '20px', color: '#9E9E9E' }} />  )
           )
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName',
            sorter: true,
            width: 110
        },
        {
            title: 'URL Video',
            dataIndex: 'url',
            key: 'url',
            sorter: false,
            width: 250,
            hidden: !isSuperAdmin(),
            render: (text, record) => {
                return (
                    <Tooltip placement="bottom" title={'Ver Video'}>
                        <IconButton className={props.classes.editIcon} onClick={() => openInNewTab(record)} disabled={record.url == null}>
                            <Icon type='eye' />
                        </IconButton>
                    </Tooltip>
                )
            },
        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idCourse',
            fixed: 'right',
            width: siteId === 'HUB' ? 320 : 80,
            render: (text, record) => {
                return (
                    <div>
                        {
                            siteId === 'HUB' ?
                                <Tooltip placement="bottom" title={'Eliminar'}>
                                    <IconButton disabled className={props.classes.deleteIcon} onClick={() => showConfirmDelete(record)} disabled={record.statusName === 'ASIGNADO' || record.statusName === 'BAJA'}>
                                        <Icon type="delete" />
                                    </IconButton>
                                </Tooltip> : null
                        }
                        <Tooltip placement="bottom" title={siteId === 'HUB' && record.statusName !== 'BAJA' ? 'Editar' : 'Visualizar'}>
                            <IconButton className={props.classes.editIcon} onClick={() => showTabEdit(record)}>
                                <Icon type={siteId === 'HUB' && record.statusName !== 'BAJA' ? 'edit' : 'eye'} />
                            </IconButton>
                        </Tooltip>
                        {
                            siteId === 'HUB' ?
                                <Tooltip placement="bottomLeft" title={'Ver Respuestas'}>
                                    <IconButton className={props.classes.editIcon} onClick={() => showModalViewAnswers(record)}>
                                        <Icon type="question-circle" />
                                    </IconButton>
                                </Tooltip>
                                :
                                null
                        }
                        {/* <Tooltip placement="bottomLeft" title={'Ver Respuestas'}>
                            <IconButton className={props.classes.editIcon} onClick={() => showModalViewAnswers(record)}>
                                <Icon type="question-circle" />
                            </IconButton>
                        </Tooltip> */}

                        {
                            siteId === 'HUB' ?
                                <Tooltip placement="bottom" title={'Suspender'}>
                                    <IconButton onClick={() => showConfirmSuspend(record)} disabled={record.statusName === 'ASIGNADO' || record.statusName === 'BAJA'} style={{ color: (record.statusName === 'ASIGNADO' || record.statusName === 'BAJA') ? "#989898" : "#26A6D3" }} >
                                        <Icon type="poweroff" />
                                    </IconButton>
                                </Tooltip> : null
                        }
                        {
                            siteId === 'HUB' ?
                                <Tooltip placement="bottom" title={'Versionar'}>
                                    <IconButton className={props.classes.versionIcon} onClick={() => showTabVersion(record)} disabled={record.statusName !== 'ASIGNADO' && record.statusName !== 'LISTO'}>
                                        <Icon type="fork" />
                                    </IconButton>
                                </Tooltip> : null
                        }
                        {
                            siteId === 'HUB' ?
                                <Tooltip placement="bottom" title={'Reactivar Video'}>
                                    <IconButton className={props.classes.restoreIcon} onClick={() => activeVideo(record.idMultimedia)} disabled={!record.isDownload}>
                                        <Icon type="undo" />
                                    </IconButton>
                                </Tooltip> : null
                        }
                        {
                            siteId === 'HUB' ?
                                <Tooltip placement="bottom" title={'Restablecer'}>
                                    <IconButton className={props.classes.editIcon} onClick={() => restoreCourse(record.idCourse)} disabled={record.statusName !== 'BAJA'}>
                                        <Icon type="rollback" />
                                    </IconButton>
                                </Tooltip> : null
                        }
                    </div>
                )
            },
        },
    ].filter(item => !item.hidden);;

    const showModalViewAnswers = (param) => {
        props.setIdCourse(param.idCourse);
        props.currentViewAnswers(param.showAnswers);
    }

    const showTabEdit = (param) => {
        dispatch(courseCategoryAvailableClear([]));
        dispatch(courseCategoryAvailableApproveClear([]));
        dispatch(courseCategoryClear());
        dispatch(courseCategoryApproveClear())
        dispatch(courseTestAvailableClear());
        dispatch(courseTestClear());
        dispatch(courseWorkCycleClear());
        dispatch(courseWorkCycleAvailableClear());
        dispatch(attachmentClear());
        dispatch(clearCourseMultimedia());
        dispatch(courseFilterClear());
        dispatch(fetchCourseFilter({
            employeeId: employeeId,
            subdirectionId: idSubdirection
        }));
        dispatch(courseClientProcedureAvailableClear());
        dispatch(courseClientProcedureClear());
        dispatch(courseHomologousProcedureAvailableClear());
        dispatch(courseHomologousProcedureClear());
        props.setTab('3');
        props.setIdCourse(param.idCourse);
    }
    function openInNewTab(record) {

        fetch(record.url)
            .then(res => res.blob())
            .then(blob => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${record.courseCode}.mp4`;
                document.body.append(link);
                link.click();
                link.remove();
                window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
            })
    }

    const showTabVersion = (param) => {
        dispatch(courseCategoryAvailableClear());
        dispatch(courseCategoryClear());
        dispatch(courseTestAvailableClear());
        dispatch(courseTestClear());
        dispatch(courseWorkCycleClear());
        dispatch(courseWorkCycleAvailableClear());
        dispatch(attachmentClear());
        dispatch(clearCourseMultimedia());
        dispatch(courseFilterClear());
        dispatch(fetchCourseFilter({
            employeeId: employeeId,
            subdirectionId: idSubdirection
        }));
        dispatch(courseClientProcedureAvailableClear());
        dispatch(courseClientProcedureClear());
        dispatch(courseHomologousProcedureAvailableClear());
        dispatch(courseHomologousProcedureClear());
        props.setTab('4');
        props.setIdCourse(param.idCourse);
    }

    const showTabRestore = (param) => {
        dispatch(courseCategoryAvailableClear());
        dispatch(courseCategoryClear());
        dispatch(courseTestAvailableClear());
        dispatch(courseTestClear());
        dispatch(courseWorkCycleClear());
        dispatch(courseWorkCycleAvailableClear());
        dispatch(attachmentClear());
        dispatch(clearCourseMultimedia());
        dispatch(courseFilterClear());
        dispatch(fetchCourseFilter({
            employeeId: employeeId,
            subdirectionId: idSubdirection
        }));
        dispatch(courseClientProcedureAvailableClear());
        dispatch(courseClientProcedureClear());
        dispatch(courseHomologousProcedureAvailableClear());
        dispatch(courseHomologousProcedureClear());
        props.setTab('5');
        props.setIdCourse(param.idCourse);
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Procedimiento?',
            content: param.courseName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(courseFilterClear());
                return deleteCourse(param.idCourse);
            },
            onCancel() { },
        });

    }

    const showConfirmSuspend = (record) => {
        confirm({
            title: '¿Suspender Procedimiento?',
            content: record.courseName,
            okText: 'Suspender',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(courseFilterClear());
                return suspendCourse(record.idCourse);
            },
            onCancel() { },
        });
    }

    async function suspendCourse(id) {
        await ApiService.suspendCourse(id).then(res => {
            dispatch(courseClear());
            dispatch(courseFilterClear());
            dispatch(fetchCourseFilter({
                employeeId: employeeId,
                subdirectionId: idSubdirection
            }));
            dispatch(fetchCourse(
                {
                    ...props.formData,
                    employeeId: employeeId,
                    subdirectionId: idSubdirection,
                    IsAdminGeneral: validateAdminGeneralRol(),
                    PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : [],
                    IsSuperAdmin: isSuperAdmin()
                }
            ));
            const modal = Modal.success({
                title: `Suspendido Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    async function restoreCourse(id) {
        await ApiService.setRestoreCourse(id).then(res => {
            dispatch(courseClear());
            dispatch(courseFilterClear());
            dispatch(fetchCourseFilter({
                employeeId: employeeId,
                subdirectionId: idSubdirection
            }));
            dispatch(fetchCourse(
                {
                    ...props.formData,
                    employeeId: employeeId,
                    subdirectionId: idSubdirection,
                    IsAdminGeneral: validateAdminGeneralRol(),
                    PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : [],
                    IsSuperAdmin: isSuperAdmin()
                }
            ));
            const modal = Modal.success({
                title: `Restablecido Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    async function deleteCourse(id) {
        await ApiService.deleteCourse(id).then(res => {
            dispatch(courseClear());
            dispatch(courseFilterClear());
            dispatch(fetchCourseFilter({
                employeeId: employeeId,
                subdirectionId: idSubdirection
            }));
            dispatch(fetchCourse(
                {
                    ...props.formData,
                    employeeId: employeeId,
                    subdirectionId: idSubdirection,
                    IsAdminGeneral: validateAdminGeneralRol(),
                    PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : [],
                    IsSuperAdmin: isSuperAdmin()
                }
            ));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    async function activeVideo(id) {
        await ApiService.setActiveVideo(id).then(res => {
            dispatch(courseClear());
            dispatch(courseFilterClear());
            dispatch(fetchCourseFilter({
                employeeId: employeeId,
                subdirectionId: idSubdirection
            }));
            dispatch(fetchCourse(
                {
                    ...props.formData,
                    employeeId: employeeId,
                    subdirectionId: idSubdirection,
                    IsAdminGeneral: validateAdminGeneralRol(),
                    PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : [],
                    IsSuperAdmin: isSuperAdmin()

                }
            ));
            const modal = Modal.success({
                title: `Reactivado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let course = useSelector(getCourse);
    let courseFilter = useSelector(getCourseFilter);

    let isLoading = useSelector(getIsLoadingCourse);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(course)) fetchCourseAction();
        if (isEmpty(courseFilter)) fetchCourseFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchCourse({
            employeeId: employeeId,
            subdirectionId: idSubdirection,
            CourseFolio: (props.formData.CourseFolio === undefined) ? '' : props.formData.CourseFolio,
            CourseName: (props.formData.CourseName === undefined) ? '' : props.formData.CourseName,
            TestFolio: (props.formData.TestFolio === undefined) ? '' : props.formData.TestFolio,
            TestCTFolio: (props.formData.TestCTFolio === undefined) ? '' : props.formData.TestCTFolio,
            Status: (props.formData.Status === undefined) ? '' : props.formData.Status,
            Subdirection: (props.formData.Subdirection === undefined) ? '' : props.formData.Subdirection,
            CourseVersion: (props.formData.CourseVersion === undefined) ? '' : props.formData.CourseVersion,
            CourseCode: (props.formData.CourseCode === undefined) ? '' : props.formData.CourseCode,
            CourseDateCreationInitial: (props.formData.CourseDateCreationInitial === undefined) ? '' : props.formData.CourseDateCreationInitial,
            CourseDateCreationFinal: (props.formData.CourseDateCreationFinal === undefined) ? '' : props.formData.CourseDateCreationFinal,
            CourseDateModificationInitial: (props.formData.CourseDateModificationInitial === undefined) ? '' : props.formData.CourseDateModificationInitial,
            CourseDateModificationFinal: (props.formData.CourseDateModificationFinal === undefined) ? '' : props.formData.CourseDateModificationFinal,
            Trainings: (props.formData.Training === undefined) ? '' : props.formData.Training,
            SystemSpecialty: (props.formData.SystemSpecialty === undefined) ? '' : props.formData.SystemSpecialty,
            Categories: (props.formData.Categories === undefined) ? '' : props.formData.Categories,
            NotSuspended: (props.formData.NotSuspended === undefined) ? false : props.formData.NotSuspended,
            // FolioPDC: (props.formData.FolioPDC === undefined) ? '' : props.formData.FolioPDC,
            // FichaUsuario: (props.formData.FichaUsuario === undefined) ? '' : props.formData.FichaUsuario,
            sortColumn: column,
            sortDir: order,
            offset: ((pagination.current - 1) * pagination.pageSize),
            limit: pagination.pageSize,
            IsAdminGeneral: validateAdminGeneralRol(),
            PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : [],
            IsSuperAdmin: isSuperAdmin()

        }))

    };

    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && course.length > 0) {
            pagination.total = course[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }


    const fetchCourseAction = () => dispatch(fetchCourse({
        employeeId: employeeId, subdirectionId: idSubdirection, offset: offset, limit: limit, IsAdminGeneral: validateAdminGeneralRol(),
        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : [],
        IsSuperAdmin: isSuperAdmin()
    }));
    const fetchCourseFilterAction = () => dispatch(fetchCourseFilter({
        employeeId: employeeId,
        subdirectionId: idSubdirection
    }))

    return (props.children({ pagination: pagination, cols: columns, course, courseFilter, isLoading, handleTableChange: handleTableChange }));
}